export const T = {
  en_GB: { complete: "Complete", incomplete: "Incomplete" },
  nb_NO: { complete: "Fullført", incomplete: "Ufullstendig" },
} as const;
